import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import '../color/color';
import '../rule/rule';
import '../interactions/interactions';
import '../typography/typography';
import css from './tab-item.css';

const TabItem = ({ title, minor, adjacent, selected, ...props }) => (
  <li role='presentation' className={classnames(css['ds-tab-item'])}>
    <a
      role='tab'
      title={title}
      aria-selected={selected}
      className={classnames(css['ds-tab-item__link'], {
        [css['ds-tab-item__link--adjacent']]: adjacent,
        [css['ds-tab-item__link--minor']]: minor,
        [css['ds-tab-item__link--selected']]: selected,
      })}
      {...props}
    >
      {title}
    </a>
  </li>
);

TabItem.defaultProps = {
  minor: null,
  title: null,
  adjacent: false,
  selected: false,
};

TabItem.propTypes = {
  minor: PropTypes.bool,
  title: PropTypes.string,
  adjacent: PropTypes.bool,
  selected: PropTypes.bool,
};

export default TabItem;
